import { firebaseApi as api } from '../constants';
import { cloudRunInstance as axios, instance } from './axios/firebase';

export const fetchAll = ({ store, search }) => {
  return axios.get(api.orders.fetchAll, {
    params: {
      store_id: store,
      q: search,
    },
  });
};

export const parseOrders = () => {
  return axios.get(api.orders.parse);
};
export const parseOrdersNewWT = () => {
  return instance.get(api.orders.newWT);
};
